import { render, staticRenderFns } from "./approvalManagement.vue?vue&type=template&id=59d791db&scoped=true"
import script from "./approvalManagement.vue?vue&type=script&lang=js"
export * from "./approvalManagement.vue?vue&type=script&lang=js"
import style0 from "./approvalManagement.vue?vue&type=style&index=0&id=59d791db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d791db",
  null
  
)

export default component.exports